/* Lines up product cards in each row (collection pages and every product grid).
   Full titles stay as they are, so they run one, two or three lines, and Heritage suits add an
   "Italian wool · half-canvas" line. Here every card in a visual row gets the same title-plus-descriptor height,
   so prices, swatches and reviews start at the same height across the row. Re-runs when the layout changes. */
(() => {
  if (window.__gCardAlign) return;
  window.__gCardAlign = true;
  const CARD = '.g-collection-card';
  let queued = false;

  const align = () => {
    queued = false;
    const items = [];
    document.querySelectorAll(CARD).forEach((card) => {
      const title = card.querySelector('.g-collection-card__title');
      if (!title || !card.offsetParent) return;
      title.style.minHeight = '';
      items.push({ card, title });
    });
    const rows = new Map();
    items.forEach((it) => {
      const desc = it.card.querySelector('.g-collection-card__descriptor');
      const gap = desc ? parseFloat(getComputedStyle(it.title.parentElement).rowGap) || 0 : 0;
      it.extra = desc ? desc.getBoundingClientRect().height + gap : 0;
      it.height = it.title.getBoundingClientRect().height + it.extra;
      const top = Math.round(it.card.getBoundingClientRect().top + window.scrollY);
      const key = String(top);
      if (!rows.has(key)) rows.set(key, []);
      rows.get(key).push(it);
    });
    rows.forEach((row) => {
      if (row.length < 2) return;
      const tallest = Math.max(...row.map((it) => it.height));
      row.forEach((it) => {
        const need = tallest - it.extra;
        if (need - it.title.getBoundingClientRect().height > 0.5) it.title.style.minHeight = `${need.toFixed(2)}px`;
      });
    });
  };

  // setTimeout as well as requestAnimationFrame: animation frames pause in background tabs.
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(align);
    setTimeout(() => { if (queued) align(); }, 120);
  };

  let width = window.innerWidth;
  window.addEventListener('resize', () => { if (window.innerWidth !== width) { width = window.innerWidth; schedule(); } });
  window.addEventListener('load', schedule);
  document.fonts?.ready.then(schedule);
  document.addEventListener('shopify:section:load', schedule);
  new MutationObserver((records) => {
    for (const r of records) {
      for (const n of r.addedNodes) {
        if (n.nodeType === 1 && (n.matches?.(CARD) || n.querySelector?.(CARD))) { schedule(); return; }
      }
      if (r.type === 'attributes' && (r.target.matches?.(CARD) || r.target.querySelector?.(CARD))) { schedule(); return; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true });
  else schedule();
})();
